import { render, staticRenderFns } from "./province-select-index.vue?vue&type=template&id=a2b67a8a&scoped=true&"
import script from "./province-select-index.vue?vue&type=script&lang=js&"
export * from "./province-select-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b67a8a",
  null
  
)

export default component.exports